import React, { Component } from 'react';
import { Link } from 'gatsby';
import { classnames, classname } from 'utils';

import './NotFound.css';

class NotFound extends Component {
  cl = classname('not-found');

  render() {
    const { className } = this.props;

    const classes = classnames(className, this.cl());

    return (
      <div className={classes}>
        <div className={this.cl('data')}>
          <div className={this.cl('title')}>Высший балл!</div>
          <div className={this.cl('text')}>Поздравляем! Вы нашли страницу с&nbsp;интегральным рейтингом 404</div>
          <Link to="/" className={this.cl('link')}>
            На главную
          </Link>
        </div>
        <div className={this.cl('visual')}>
          <ul className={this.cl('list')}>
            <li className={this.cl('item')}>
              <div className={this.cl('value')}>404</div>
            </li>
            <li className={this.cl('item')}>
              <div className={this.cl('value')}>404</div>
            </li>
            <li className={this.cl('item')}>
              <div className={this.cl('value')}>404</div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default NotFound;
